export const CONTACT_EMAIL = "danielle@mavenskies.ca";

// Paste real URLs here when ready; empty values fall back to a pre-filled email.
export const TICKETS_URL = "";
export const PROGRAM_PDF_URL = "";

const mail = (subject) => `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;

export const APPLY_HREF = "/program#apply";
export const TICKETS_HREF = TICKETS_URL || mail("Tech Night at the Globe: seat reservation");
export const CONVERSATION_HREF = mail("Starting a conversation");

export const NAV_LINKS = [
  { label: "Our Approach", href: "/approach" },
  {
    label: "Programs",
    children: [
      { label: "All Programs", href: "/program" },
      { label: "Founder Readiness", href: "/program#founder" },
      { label: "Angel Readiness", href: "/angels#readiness" },
    ],
  },
  { label: "Angels", href: "/angels" },
  { label: "Groundwork", href: "/groundwork" },
  { label: "MavenCircle", href: "/mavencircle" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export const FOOTER_LINKS = [...NAV_LINKS.flatMap((l) => (l.children ? [l.children[0]] : [l])), { label: "Privacy", href: "/privacy" }, { label: "Terms", href: "/terms" }];

export const DISCLAIMER =
  "Maven Skies convenes investors and founders and shares information. It does not provide investment advice, recommend investments or solicit investment in any company. Members make their own investment decisions.";

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
